import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../../components/WMS/Mobile/Popup";
import {deleteAssociation} from "../../../../../../api/wms/wmsAssociation/wmsAssociation";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import {WMSContext} from "../../../../context/WMSContext";

DeleteAssociationModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    association: PropTypes.object.isRequired
};

function DeleteAssociationModal({open, handleClose, association}) {
    const {isMobile} = useContext(WMSContext)
    const handleValid = () => {
        deleteAssociation(association).then(r => {
            handleClose(true, 'delete')
        })
    }
    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.associations.deleteModal.title"}/>}
            subtitle={<FormattedMessage id={"wms.associations.deleteModal.subtitle"}/>}
            isMobile={isMobile}
        >
            <Grid container direction={isMobile ? "column" : "row"} justifyContent={"end"} gap={"8px"}>
                <CustomButton fullWidth={!!isMobile} color={"default"} variant={"nude"} onClick={() => handleClose()}><FormattedMessage id={"wms.associations.deleteModal.cancelButton"}/></CustomButton>
                <CustomButton fullWidth={!!isMobile} color={"red"} onClick={() => handleValid()}><FormattedMessage id={"wms.associations.deleteModal.validButton"}/></CustomButton>
            </Grid>
        </Popup>
    );
}

export default DeleteAssociationModal;